module.exports = __webpack_public_path__ + "images/mdj/members/resume/quick_resume/btn_edit_sp-aa08c59df35bef55769c424eb1feda07.png";